import { render, staticRenderFns } from "./BaleList.vue?vue&type=template&id=308a836d&scoped=true"
import script from "./BaleList.vue?vue&type=script&lang=js"
export * from "./BaleList.vue?vue&type=script&lang=js"
import style0 from "./BaleList.vue?vue&type=style&index=0&id=308a836d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308a836d",
  null
  
)

export default component.exports